import { FormattedMessage } from 'react-intl';

import { FileDownload } from '@shieldpay/bumblebee/file-download';
import { Heading } from '@shieldpay/bumblebee/heading';
import FileDownloadMarkdown from '@shieldpay/bumblebee/markdown/file-download.md';
import { Text } from '@shieldpay/bumblebee/text';

import { Link } from '@shieldpay/utilities-ui/link';

import { ContentsTable } from '~/components/contents-table/contents-table';
import { Design } from '~/components/design/design';
import { MdxFormatter } from '~/components/mdx-formatter/mdx-formatter';
import { ComponentPreview } from '~/components/preview/component-preview';
import { createMeta } from '~/utilities/create-meta';

export const meta = createMeta({
  id: 'hive.components.fileDownload.title',
});

export const FileDownloadComponentPage = () => {
  return (
    <>
      <Heading>
        <FormattedMessage id="hive.components.fileDownload.title" />
      </Heading>

      <ContentsTable />

      <ComponentPreview spacing="basePos5">
        <FileDownload filePath="/file-download-example.txt" variant="solid">
          <FormattedMessage id="hive.components.fileDownload.text" />
        </FileDownload>
      </ComponentPreview>
      <Design>
        <Text paragraph>
          <Link to="/components/link#design">
            <FormattedMessage id="hive.components.fileDownload.design" />
          </Link>
        </Text>
      </Design>

      <MdxFormatter md={FileDownloadMarkdown} />
    </>
  );
};

export default FileDownloadComponentPage;
